<script>
    import {PAGE_ID, router, navigateTo} from "../../stores/router";
    import DealsList from "../DealsList.svelte";
    import {deals} from "../../stores/deals";
    import {selectDeal} from "../../stores/misc";

    const onDealClick = id => {
        selectDeal(id);
        navigateTo(PAGE_ID.VIEW_DEAL);
    };
</script>


<div class="absolute top-16 right-0 bottom-0 left-0 overflow-y-auto" class:hidden={$router.current_page !== PAGE_ID.DEALS}>

    <!-- Header -->
    <div class="px-4 sm:px-6 lg:px-8">

        <!--        <Breadcrumbs></Breadcrumbs>-->

        <div class="h-16 flex items-center md:justify-between">
            <div class="min-w-0 flex-1">
                <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">Deals</h2>
            </div>
            <div class="flex flex-shrink-0 md:mt-0 md:ml-4">
                <!--                <button type="button" class="inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">Edit</button>-->
                <!--                <button type="button" class="ml-3 inline-flex items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">Publish</button>-->
                <button on:click={() => navigateTo(PAGE_ID.ADD_DEAL)}
                        type="button" class="relative inline-flex items-center rounded-md border border-transparent bg-indigo-500 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-800">
                    <!-- Heroicon name: mini/plus -->
                    <svg class="-ml-1 mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z" />
                    </svg>
                    <span>Add Deal</span>
                </button>
            </div>
        </div>
    </div>

    <!-- Content -->
    <div class="px-4 sm:px-6 lg:px-8">
        <DealsList deals_arr_list={$deals.list} on:dealClicked={(e) => onDealClick(e.detail.id)}></DealsList>
    </div>

</div>


<style></style>